var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { properties, isSpecHome, heading } = options 
__p+='\n\n';
 if (properties && properties.length) { 
__p+='\n  <div class="subsection">\n    <h2 class="header-subsection">\n      '+
((__t=( heading ))==null?'':__t)+
'\n      ';
 if (!isSpecHome) { 
__p+='\n        <a\n        href="javascript:void(0)"\n        class="pull-right compare-link"\n        id="otherPlansCompare"\n        data-toggle="modal"\n        data-target="compareModal"\n        >Compare properties</a\n      >\n    ';
 } 
__p+='\n    </h2>\n    <div class="component_bm-carousel">\n      <div class="rdc-carousel">\n        <div class="owl-carousel">\n          ';
 properties.forEach((property, listing_index) => { 
__p+='\n            '+
((__t=( JST["quick_view/templates/other-plans/other-plans-card"]({property, listing_index, isSpecHome}) ))==null?'':__t)+
'\n          ';
 }) 
__p+='\n        </div>\n        <div class="rdc-carousel-nav">\n          <div class="rdc-prev-set hide"><i class="ra ra-angle-left"></i></div>\n          <div class="rdc-next-set"><i class="ra ra-angle-right"></i></div>\n        </div>\n      </div>\n    </div>\n  </div>\n';
 }
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/other-plans/other-plans-carousel.jst.ejs